import { AppRouter } from "@/lib/router";
import { AppErrorBoundary } from "@/components/ErrorBoundary";
import "./index.css";

export function App() {
  return (
    <AppErrorBoundary>
      <AppRouter />
    </AppErrorBoundary>
  );
}

export default App;
